import { AsciiText } from '../framework/AsciiText';
export class NecProjector {
    constructor(socket, log) {
        this.socket = socket;
        this.displayBlank = false;
        this.displayFreeze = false;
        this.power = false;
        this.productName = 'P554U'.padEnd(32, '\x00');
        this.serialNumber = '123456'.padEnd(16, '\x00');
        this.videoInput = 0x1a; // HDMI 1 in hex
        this.volume = 10;
        this.volumeMute = false;
        this.sourceMap = {
            0xa1: 0x1a,
            0xbf: 0x20, // HDBaseT
        };
        this.asyncHandlers = [
            {
                name: 'basicInformationRequest',
                regExp: /\x00\xbf[\s\S]{2}\x01\x02[\s\S]/,
                callback: (match) => {
                    this.socket.send(this.makeCommand([
                        0x20,
                        0xbf,
                        0x00,
                        0x00,
                        0x10,
                        0x02,
                        this.power ? 0x04 : 0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x21,
                        this.displayBlank ? 0x01 : 0x00,
                        this.volumeMute ? 0x01 : 0x00,
                        0x00,
                        this.displayFreeze ? 0x01 : 0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00, // Data15
                    ]));
                },
            },
            {
                name: 'displayBlankSet',
                regExp: /\x02([\x10\x11])[\s\S]{2}\x00[\s\S]/,
                callback: (match) => {
                    this.displayBlank = match[1] === '\x10';
                    this.socket.send(this.makeCommand([0x22, match[1].charCodeAt(0), 0x00, 0x00, 0x00]));
                },
            },
            {
                name: 'displayFreezeSet',
                regExp: /\x01\x98[\s\S]{2}\x01([\x01\x02])[\s\S]/,
                callback: (match) => {
                    this.displayFreeze = match[1] === '\x01';
                    this.socket.send(this.makeCommand([
                        0x21,
                        0x98,
                        0x00,
                        0x00,
                        0x01,
                        this.displayFreeze ? 0x01 : 0x02,
                    ]));
                },
            },
            {
                name: 'serialNumber',
                regExp: /\x00\xbf[\s\S]{2}\x02\x01\x06[\s\S]/,
                callback: (match) => {
                    this.socket.send(this.makeCommand([
                        0x20,
                        0xbf,
                        0x00,
                        0x00,
                        0x12,
                        0x01,
                        0x06,
                        ...AsciiText.encode(this.serialNumber),
                    ]));
                },
            },
            {
                name: 'powerSet',
                regExp: /\x02([\x00\x01])[\s\S]{2}\x00[\s\S]/,
                callback: (match) => {
                    this.power = match[1] === '\x00';
                    //console.log(`emulator: setting power to ${this.power}`);
                    this.socket.send(this.makeCommand([0x22, match[1].charCodeAt(0), 0x00, 0x00, 0x00]));
                },
            },
            {
                name: 'inputStatusRequest',
                regExp: /\x00\x85[\s\S]{2}\x01\x02[\s\S]/,
                callback: (match) => {
                    this.socket.send(this.makeCommand([
                        0x20,
                        0x85,
                        0x00,
                        0x00,
                        0x10,
                        0x00,
                        this.videoInput - 0x01,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00, // Data16
                    ]));
                },
            },
            {
                name: 'productNameQuery',
                regExp: /\x00\x85[\s\S]{2}\x01\x04[\s\S]/,
                callback: (match) => {
                    this.socket.send(this.makeCommand([
                        0x20,
                        0x85,
                        0x00,
                        0x00,
                        0x20,
                        ...AsciiText.encode(this.productName),
                    ]));
                },
            },
            {
                name: 'runningStatusRequest',
                regExp: /\x00\x85[\s\S]{2}\x01\x01[\s\S]/,
                callback: (match) => {
                    this.socket.send(this.makeCommand([
                        0x20,
                        0x85,
                        0x00,
                        0x00,
                        0x10,
                        0x00,
                        0x00,
                        this.power ? 0x01 : 0x00,
                        0x00,
                        0x00,
                        this.power ? 0x04 : 0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00, // Data16
                    ]));
                },
            },
            {
                name: 'inputChange',
                regExp: /\x02\x03[\s\S]{2}\x02\x01([\s\S])[\s\S]/,
                callback: (match) => {
                    const vid = match[1].charCodeAt(0);
                    this.videoInput = vid in this.sourceMap ? this.sourceMap[vid] : vid;
                    this.socket.send(this.makeCommand([0x22, 0x03, 0x00, 0x00, 0x01, 0x00]));
                },
            },
            {
                name: 'volumeQuery',
                regExp: /\x03\x05[\s\S]{2}\x03\x05\x00\x00[\s\S]/,
                callback: (match) => {
                    this.socket.send(this.makeCommand([
                        0x23,
                        0x05,
                        0x00,
                        0x00,
                        0x10,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        this.volume & 0xff,
                        (this.volume >> 8) & 0xff,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00, // Data16
                    ]));
                },
            },
            {
                name: 'volumeSet',
                regExp: /\x03\x10[\s\S]{2}\x05\x05\x00([\s\S]{3})[\s\S]/,
                callback: (match) => {
                    const mode = match[1].charCodeAt(0); // 0 absolute, 1 increment
                    const value = match[1].charCodeAt(1) + ((match[1].charCodeAt(2) << 8) & 0xff);
                    this.volume = mode === 0 ? value : this.volume + value;
                    this.socket.send(this.makeCommand([0x23, 0x10, 0x00, 0x00, 0x02, 0x00, 0x00]));
                },
            },
            {
                name: 'volumeMuteSet',
                regExp: /\x02([\x12\x13])[\s\S]{2}\x00[\s\S]/,
                callback: (match) => {
                    this.volumeMute = match[1] === '\x12';
                    this.socket.send(this.makeCommand([0x22, 0x12, 0x00, 0x00, 0x00]));
                },
            },
            {
                name: 'errorStatusRequest',
                regExp: /\x00\x88[\s\S]{2}\x00[\s\S]/,
                callback: (match) => {
                    this.socket.send(this.makeCommand([
                        0x20,
                        0x88,
                        0x00,
                        0x00,
                        0x0c,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                    ]));
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`401-`);
                },
            },
        ];
    }
    makeCommand(data) {
        const bytes = data;
        const checksum = bytes.reduce((sum, current) => sum + current);
        bytes.push(checksum & 0x00ff);
        return AsciiText.decode(bytes);
    }
    onConfigure(config) {
        var _a;
        let lowestCode;
        for (const videoInput of Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {})) {
            if (this.videoInput === lowestCode)
                return;
            if (lowestCode === undefined || videoInput.code.charCodeAt(0) - 0x30 < lowestCode) {
                lowestCode = videoInput.code.charCodeAt(0) - 0x30;
            }
        }
        lowestCode = lowestCode !== null && lowestCode !== void 0 ? lowestCode : 0x1a;
        this.videoInput = lowestCode;
    }
    commandExtractor(buffer) {
        // Command Format:
        //       0          1        2     3        4        5 - 41            42
        //   [command] [command2] [ID1] [ID2] [DataLength] [data: 0-36 bytes] [checksum]
        //
        // There can be more than 36 bytes of data.
        //
        // The shecksum is lower 8-bits of the sum of all the bytes in the command.
        //
        // Acknowledgments are at least 6 bytes long (i.e., when the data length is 0) and can be
        // longer.
        let i = 0;
        const startBytes = [
            String.fromCharCode(0x00),
            String.fromCharCode(0x01),
            String.fromCharCode(0x02),
            String.fromCharCode(0x03),
        ];
        // Skip over any garbage characters at the beginning of the command.
        while (!startBytes.includes(buffer[i]) && i < buffer.length)
            i++;
        // Make sure we have enough data to compute the command length.
        if (buffer.length - i < 6)
            return undefined;
        // 5 comes from getting past the header bytes 0,1,2,3,4 + the length + the checksum
        const numCmdBytes = 5 + buffer.charCodeAt(i + 4) + 1;
        // Make sure we have the full command.
        if (buffer.length - i < numCmdBytes)
            return undefined;
        let checksum = 0;
        for (let j = 0; j < numCmdBytes - 1; j++) {
            checksum += buffer.charCodeAt(i + j);
        }
        checksum &= 0x00ff;
        let command;
        if (checksum === buffer.charCodeAt(i + numCmdBytes - 1)) {
            command = buffer.slice(i, i + numCmdBytes);
        }
        buffer = buffer.slice(i + numCmdBytes);
        return { command, buffer };
    }
}
NecProjector.emulatorType = 'socketEmulator';
NecProjector.key = '-LRMc4JVp7tCiIQfQAQ5';
